import { render, staticRenderFns } from "./CellRendererCustomer.vue?vue&type=template&id=bec5bc58&scoped=true"
import script from "./CellRendererCustomer.vue?vue&type=script&lang=js"
export * from "./CellRendererCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec5bc58",
  null
  
)

export default component.exports